export const VmStatus = {
    Starting: "starting",
    Running: "running",
    Stopping: "stopping",
    Stopped: "stopped",
    Deallocating: "deallocating",
    Deallocated: "deallocated",
    Unknown: "unknown",
    Deleting:'deleting',
    Provisioning:'provisioning',
    Pending:'pending',
    Provisioning_Failed:'provisioning_failed',
    Deletion_Failed:'deletion_failed',
    Deleted:'deleted'
} as const;

